













































































































































































































import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import _debounce from 'lodash/debounce';
import { Subscription } from 'rxjs';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwCheckbox } from '../sw-checkbox';
import { SwSpinningProgress } from '../sw-progress';
import { SwIcon } from '../sw-icon';
import SwTableRowFloatActions from './sw-table-row-float-actions.vue';
import SwTable from './sw-table.vue'; // only for types
import { utilService, EVENT_TYPE } from './util.service';
import {
  TableColumnConfig,
  TableEntry,
  TableRowClaimExpandEventData,
  TableColumnRenderFunc,
  TableRowExpandMode,
  TableEntryFloatActionsGenerator,
  TableEntryFloatAction,
  TableBodyMetrics,
  ClaimedRowInsertCaret,
  FloatActionPlacement,
  FloatActionPointerPos,
  InternalExpandEventData,
  FloatActionOffset,
} from './types';
import { CSSStyleOptions } from '../common-types';
import { tooltip } from '../tooltip-dir';
import { utilService as sharedUtilService } from '../util-service';
import { drag, DragDirValues, DragPosition } from '../drag-dir';

const cssPrefix = 'sw-table-row';
const i18nPathPrefix = 'libShared.SwTable';

/**
 * Events:
 * @event claim-expand `(TableRowClaimExpandEventData)`
 * @event insert-caret-info `(ClaimedRowInsertCaret)`
 * @event request-finalize-insert
 */
@Component({
  components: {
    SwTableRowFloatActions,
    SwIcon,
    SwCheckbox,
    SwSpinningProgress,
  },
  directives: {
    tooltip,
    drag,
  },
})
export default class SwTableRow extends SwExtendedVue {
  @Prop({ type: String, required: true })
  instanceId: string;

  @Prop({ type: Array, required: true })
  columnsConfig: TableColumnConfig[];

  @Prop({ type: Array, required: true })
  effectiveColumnsConfig: TableColumnConfig[];

  @Prop({ type: Object, required: false })
  entry: TableEntry | undefined | null;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: String, required: true })
  effectiveExpandMode: TableRowExpandMode;

  @Prop({ type: Function })
  expandRender: TableColumnRenderFunc;

  @Prop({ type: String, required: true })
  theme: SwTable['theme'];

  @Prop({ type: String, required: true })
  size: SwTable['size'];

  @Prop({ type: Boolean, required: true })
  stripe: boolean;

  @Prop({ type: Boolean, required: true })
  border: boolean;

  @Prop({ type: Number, required: true })
  nestLevel: number;

  @Prop({ type: Number, required: true })
  indentSize: number;

  @Prop({ type: Boolean, required: true })
  noBackground: boolean;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  expanded: boolean;

  @Prop({ type: Array, default() { return []; } })
  selectedArr: string[];

  @Prop({ type: Array, default() { return []; } })
  expandedArr: string[];

  @Prop({ type: Function })
  getFloatActions: TableEntryFloatActionsGenerator;

  @Prop({ type: Object, required: true })
  bodyMetrics: TableBodyMetrics;

  @Prop({ type: Boolean, default: false })
  forTreeTable: boolean;

  @Prop({ type: Boolean, required: true })
  forFixedPortion: boolean;

  @Prop({ type: Boolean, required: true })
  clickRowToExpand: boolean;

  @Prop({ type: Boolean, required: true })
  clickRowToSelect: boolean;

  @Prop({ type: Boolean, default: false })
  isLoadingData: boolean;

  @Prop({ type: Array, required: true })
  columnsStyle: CSSStyleOptions[];

  @Prop({ type: Boolean, required: true })
  rowDraggable: boolean;

  @Prop({ type: String, required: true })
  floatActionPosition: FloatActionPlacement;

  @Prop({ type: Boolean, default: false })
  holdingSelecting: boolean;

  cssPrefix = cssPrefix;
  i18nPathPrefix = i18nPathPrefix;

  isHover: boolean = false;
  isDragging: boolean = false;
  timeToShowFloatActions: boolean = false;
  floatActionPointerPos: FloatActionPointerPos | null = null;

  reactiveEntry = this.entry;
  dragStartRect: ClientRect | null = null;

  eventSubscription: Subscription | null = null;

  get treeCellWrapperStyles(): CSSStyleOptions {
    const styles: CSSStyleOptions = {};
    if (this.nestLevel > 0) {
      styles.paddingLeft = `${this.nestLevel * this.indentSize}px`;
    }
    return styles;
  }

  get isWithFixedColumns(): boolean {
    return this.effectiveColumnsConfig.length > 0 &&
      (this.effectiveColumnsConfig[0].fixed === true || this.effectiveColumnsConfig[this.effectiveColumnsConfig.length - 1].fixed === true);
  }

  get couldShowFloatActions() {
    return this.timeToShowFloatActions && !!this.getFloatActions;
  }

  get effectiveSelectable(): boolean {
    if (!this.entry) { return false; }
    return !(this.entry._selectable === false);
  }

  get effectiveExpandable(): boolean {
    if (!this.entry) { return false; }
    return utilService.isRowExpandable(this.effectiveColumnsConfig, this.entry, this.effectiveExpandMode, this.expandRender);
  }

  get delayedDetermineIfShowFloatActions() {
    return _debounce(
      (pos?: FloatActionPointerPos) => {
        this.timeToShowFloatActions = this.isHover && !!this.getFloatActions;
        if (pos) {
          this.floatActionPointerPos = pos;
        }
      },
      270,
    );
  }

  @Inject()
  readonly claimEntrySelected: SwTable['claimEntrySelected'];

  @Inject()
  readonly claimEntryExpanded: SwTable['claimEntryExpanded'];

  @Inject()
  readonly claimCellClicked: SwTable['claimCellClicked'];

  /** // FIXME: more accurate!!! the row element should be sibling of this row */
  private getRowElementFromClientPoint(point: { x: number; y: number; }): HTMLElement | null {
    const el = document.elementFromPoint(point.x, point.y);
    if (!el) { return null; }
    const rowEl = el.closest(`.${this.cssPrefix}--${this.instanceId}`);
    if (!rowEl) { return null; }
    return rowEl as HTMLElement;
  }

  @Watch('effectiveSelectable')
  private onSelectableChange(selectable: boolean, oldSelectable: boolean) {
    if (this.entry && oldSelectable && !selectable) {
      if (this.selectedArr.indexOf(this.entry._key) >= 0) {
        this.claimEntrySelected(this.entry, false);
      }
    }
  }

  @Watch('effectiveExpandable')
  private onExpandableChange(expandable: boolean, oldExpandable: boolean) {
    if (this.entry && oldExpandable && !expandable) {
      if (this.expandedArr.indexOf(this.entry._key) >= 0) {
        this.claimEntryExpanded(this.entry, false);
      }
    }
  }

  private onChangeSelected(selected: boolean) {
    if (!this.entry) { return; }
    if (!this.effectiveSelectable) { return; }
    this.claimEntrySelected(this.entry, selected);
  }

  private onTryExpand() {
    if (!this.entry) { return; }
    if (this.effectiveExpandable) {
      this.claimEntryExpanded(this.entry, !this.expanded);
      this.$emit('claim-expand', {
        el: this.$el,
        entry: this.entry,
        index: this.index,
        expanded: !this.expanded,
      } as TableRowClaimExpandEventData);
    }
  }

  private onClickRow(event: MouseEvent) {
    if (!this.entry) { return; }
    if (this.clickRowToSelect) {
      if (!this.effectiveSelectable) { return; }
      this.claimEntrySelected(this.entry, this.holdingSelecting && event.shiftKey ? true : !this.selected, true, event);
    }
    if (this.clickRowToExpand) {
      if (!this.effectiveExpandable) { return; }
      this.onTryExpand();
    }
  }

  private onEnterRow() {
    this.isHover = true;
    this.delayedDetermineIfShowFloatActions();
  }

  private onLeaveRow() {
    this.isHover = false;
    this.delayedDetermineIfShowFloatActions.cancel();
    this.timeToShowFloatActions = false;
    this.floatActionPointerPos = null;
  }

  private onMouseMove(event: MouseEvent) {
    if (this.floatActionPosition !== 'by-pointer') { return; }
    if (this.couldShowFloatActions) {
      if (this.floatActionPointerPos && Math.abs(this.floatActionPointerPos.clientX - event.clientX) < 300) { return; }
    }
    this.delayedDetermineIfShowFloatActions({ clientX: event.clientX, clientY: event.clientY });
  }

  private onStarDrag() {
    if (!this.entry) { return; }
    this.dragStartRect = this.$el.getBoundingClientRect();
    this.isDragging = true;
  }

  private onDragging(toClientPos: DragPosition) {
    if (!this.dragStartRect) { return; }
    const offset = toClientPos.y - this.dragStartRect.top;
    const el = (this.$el as HTMLElement);
    el.style.transform = `translateY(${offset}px)`;

    const refPoint = { x: this.dragStartRect.left + 1, y: toClientPos.y + (this.dragStartRect.height / 2) };
    const toRowEl = this.getRowElementFromClientPoint(refPoint);
    const info: ClaimedRowInsertCaret = { srcEntry: this.entry!, rowEl: toRowEl };
    if (toRowEl) {
      const toRect = toRowEl.getBoundingClientRect();
      info.position = (toRect.top + (toRect.height / 2)) > refPoint.y ? 'before' : 'after';
    }
    this.$emit('insert-caret-info', info);
  }

  private onDoneDrag() {
    (this.$el as HTMLElement).style.transform = '';
    this.dragStartRect = null;
    this.isDragging = false;
    this.$emit('request-finalize-insert');
  }

  /* tslint:disable-next-line */
  private render(h: CreateElement): VNode {
    const cellsNodes: JSX.Element[] = [];
    const isTreeRow = this.entry ? Array.isArray(this.entry._children) : false;
    let treeCellFound = false;
    const tdExtraClasses: string[] = [];
    const self = this;

    function getTreeExpandTrigger(expanded: boolean) {
      return (
        <div class={[`${self.cssPrefix}__cell__trigger`, `${self.cssPrefix}__cell__trigger--inline`]}>
          <sw-icon
            name={expanded ? 'arrow-down-b' : 'arrow-right-b'}
            size={13}
            as-block
          ></sw-icon>
        </div>
      );
    }

    if (this.border) {
      tdExtraClasses.push(`${this.cssPrefix}__cell--border`);
    }
    if (this.nestLevel > 0) {
      tdExtraClasses.push(`${this.cssPrefix}__cell--nested`);
    }
    if (this.isWithFixedColumns) {
      tdExtraClasses.push(`${this.cssPrefix}__cell--with-fixed-col`);
    }

    if (this.entry) {
      let skipCellsNum = 0;
      this.effectiveColumnsConfig.forEach((colConfig, index) => {
        let value;
        let isTreeCell = false;
        let isForTypedColumn = false;

        if (skipCellsNum > 0) {
          skipCellsNum -= 1;
          return;
        }

        if (colConfig.fixed === true && !this.forFixedPortion) {
          /** we don't want to render the content of this cell as it is in the fixed column but not in the fixed portion */
          value = null;
        } else if (colConfig.type) {
          const directives: VNodeDirective[] = [];

          isForTypedColumn = true;

          if (colConfig.typedCellTooltip) {
            const dirValue = colConfig.typedCellTooltip(this.entry!, this.index);
            if (!!dirValue) {
              directives.push({
                name: 'tooltip',
                value: dirValue,
              });
            }
          }

          if (colConfig.type === 'handle') {
            value = (
              <div
                class={[
                  `${this.cssPrefix}__cell__handle`,
                  'sw-flexbox',
                ]}
                style={{
                  backgroundColor: this.entry!._indicatorColor || undefined,
                  color: this.entry!._indicatorColor ? sharedUtilService.getContrastTextColor(this.entry!._indicatorColor, true) : undefined,
                } as CSSStyleOptions}
                {...{ directives }}
              >
              {
                this.rowDraggable && this.entry!._indicatorDraggable ? (
                  <div class={[`${this.cssPrefix}__cell__handle__icon`, 'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']}
                    v-drag={{
                      start: this.onStarDrag,
                      positioning: this.onDragging,
                      done: this.onDoneDrag,
                    } as DragDirValues}
                    onClick={(event: MouseEvent) => { event.stopPropagation(); }}
                  >
                    <sw-icon
                      name="dragdable-handle"
                      size={14}
                      as-block
                    ></sw-icon>
                  </div>
                ) : null
              }
              </div>
            );
          } else if (colConfig.type === 'index') {
            value = (
              <div
                class={[
                  `${this.cssPrefix}__cell__index`,
                  { [`${this.cssPrefix}__cell__index--following`]: index > 0 },
                ]}
                {...{ directives }}
              >{String(this.index + 1)}</div>
            );
          } else if (colConfig.type === 'selection') {
            value = (
              <div class={[`${this.cssPrefix}__cell__selection`, { [`${this.cssPrefix}__cell__selection--following`]: index > 0 }]} {...{ directives }}>
                <sw-checkbox name={`check_${this.entry!._key}`} checked={this.selected} disabled={!this.effectiveSelectable}
                  theme={this.theme}
                  onChange={this.onChangeSelected}
                  nativeOnClick={(event: MouseEvent) => { event.stopPropagation(); }}
                ></sw-checkbox>
              </div>
            );
          } else if (colConfig.type === 'expand') {
            value = (
              <div class={[`${this.cssPrefix}__cell__trigger`, 'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--end-justify']} {...{ directives }}>
              {
                this.effectiveExpandable ? (
                  <div class={
                    [
                      `${this.cssPrefix}__cell__trigger__cont`,
                      { [`${this.cssPrefix}__cell__trigger__cont--expanded`]: this.expanded },
                      'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
                    ]}
                    onClick={(event: MouseEvent) => { event.stopPropagation(); this.onTryExpand(); }}
                  >
                    <sw-icon
                      name="arrow-up"
                      size={13}
                      as-block
                    ></sw-icon>
                  </div>
                ) : null
              }
              </div>
            );
          } else if (colConfig.type === 'placeholder') {
            value = (
              <div class={`${this.cssPrefix}__cell__placeholder`} {...{ directives }}></div>
            );
          }
        } else if (colConfig.render instanceof Function) {
          value = colConfig.render.call(this, this.$createElement, {
            entry: this.entry!,
            index: this.index,
          });
          if (!treeCellFound) {
            isTreeCell = true;
          }
        } else {
          value = this.entry![colConfig.dataKey!];
          if (!treeCellFound) {
            isTreeCell = true;
          }
        }
        if (value === undefined) {
          value = '';
        }

        if (isTreeCell && this.forTreeTable) {
          value = (
            <span class={`${this.cssPrefix}__cell__tree-cell-wrapper`} style={this.treeCellWrapperStyles}>
              {isTreeRow ? getTreeExpandTrigger(this.expanded) : undefined}
              {typeof value === 'boolean' ? String(value) : value}
            </span>
          );
          treeCellFound = true;
        }

        const extraClasses = tdExtraClasses.slice(0);
        const styles = Object.assign({}, this.columnsStyle[index]);
        let flexMultiplier = 0;
        let flexBasis = 0;

        if (isForTypedColumn) {
          extraClasses.push(`${this.cssPrefix}__cell--typed-col`);
        }
        if (colConfig.className) {
          if (typeof colConfig.className === 'function') {
            const name = colConfig.className(this.entry!, index);
            if (name) {
              extraClasses.push(name);
            }
          } else {
            extraClasses.push(colConfig.className);
          }
        }
        extraClasses.push('sw-flexbox');
        if (styles.width === 'auto') {
          extraClasses.push('sw-flexbox__flex');
          flexMultiplier = utilService.AUTO_COL_FLEX_MULTIPLIER;
          flexBasis = flexMultiplier;
        } else {
          flexBasis = parseInt(styles.width!, 10);
          if (colConfig.scalable) {
            flexMultiplier = flexBasis;
          }
        }
        if (flexMultiplier === 0) {
          extraClasses.push('sw-flexbox__flex-none');
        } else {
          styles.flex = `${flexMultiplier} 0 ${flexBasis}px`;
        }

        /** we only handle colspan spec for regular columns */
        // let colspan = 1;
        // const entry = this.entry!;
        // if (!isForTypedColumn && entry._colspan !== undefined) {
        //   const spec = entry._colspan[colConfig.key];
        //   if (spec !== undefined) {
        //     if (typeof spec === 'number') {
        //       colspan = Math.max(spec, 1);
        //     } else {
        //       colspan = spec(index, this.effectiveColumnsConfig);
        //     }
        //   }
        //   skipCellsNum = Math.max(colspan - 1, 0);
        // }

        const cellNode = (
          <div
            class={[`${this.cssPrefix}__cell`, ...extraClasses]}
            style={styles}
            on-click={(event: MouseEvent) => { this.claimCellClicked(this.entry!, colConfig, event); }}
          >
            <div class={[`${this.cssPrefix}__cell__wrapper`, 'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--center-items']}>
              {typeof value === 'boolean' ? String(value) : value}
            </div>
          </div>
        );

        cellsNodes.push(cellNode);
      });

      /** set up selection indicator cell */
      const selectIndicatorCell = (
        <div class={[`${this.cssPrefix}__cell`, `${this.cssPrefix}__cell--zero-col`, 'sw-flexbox__flex-none']}
          style={{ position: 'relative' }}
        >
          <div
            class={[
              `${this.cssPrefix}__cell__indi`,
              { [`${this.cssPrefix}__cell__indi--show`]: this.selected },
              'sw-flexbox__flex-none',
            ]}
          ></div>
        </div>
      );
      cellsNodes.unshift(selectIndicatorCell);

      /** after we set up all normal cells, we could append one zero-widthed cell for float actions */
      let floatActionsNode: VNode | null = null;
      // if (this.couldShowFloatActions) {
      if (!!this.getFloatActions) {
        const floatActions: TableEntryFloatAction[] = this.getFloatActions(this.entry, this.index);
        const offset: FloatActionOffset = { side: 'right', value: 0 };
        if (!this.couldShowFloatActions) {
        } else if (this.floatActionPosition === 'by-pointer') {
          offset.side = 'left';
          if (
            this.bodyMetrics.width !== null &&
            this.bodyMetrics.clientWidth !== null &&
            this.bodyMetrics.left !== null &&
            this.floatActionPointerPos
          ) {
            const rect = this.$el.getBoundingClientRect();
            const offsetX = this.floatActionPointerPos.clientX - rect.left;
            const faWidth = 29 * floatActions.length;
            const gap = 20;
            if (offsetX + gap + faWidth > this.bodyMetrics.clientWidth + this.bodyMetrics.left) {
              offset.value = offsetX - this.bodyMetrics.width - faWidth - gap;
            } else {
              offset.value = offsetX - this.bodyMetrics.width + gap;
            }
          }
        } else {
          if (
            this.bodyMetrics.width !== null &&
            this.bodyMetrics.clientWidth !== null &&
            this.bodyMetrics.left !== null &&
            this.bodyMetrics.width > this.bodyMetrics.clientWidth
          ) {
            offset.value = (this.bodyMetrics.width - this.bodyMetrics.clientWidth - this.bodyMetrics.left);
          }
        }

        floatActionsNode = floatActions.length > 0 ? (
          <sw-table-row-float-actions
            visible={this.couldShowFloatActions}
            offset={offset}
            floatActions={floatActions}
            entry={this.entry}
            index={this.index}
          />
        ) as VNode : null;
      }
      const floatActionsCell = (
        <span
          class={[
            `${this.cssPrefix}__cell`,
            `${this.cssPrefix}__cell--zero-col`,
            'sw-flexbox__flex-none',
          ]}
          style={{ position: 'relative' }}
        >
          {floatActionsNode}
        </span>
      );
      cellsNodes.push(floatActionsCell);
    } else {
      const contentNodes: JSX.Element[] = [];
      if (this.isLoadingData) {
        contentNodes.push(
          <sw-spinning-progress size={'25px'} color={sharedUtilService.colorConst.selected}/>,
          <span style={{ marginLeft: '10px' }}>{ this.$t(`${i18nPathPrefix}.loading`) }</span>,
        );
      } else {
        contentNodes.push(<span>{ this.$t(`${i18nPathPrefix}.noData`) }</span>);
      }
      cellsNodes.push((
        <div
          class={[
            `${this.cssPrefix}__cell`, ...tdExtraClasses,
            'sw-flexbox__flex', 'sw-flexbox',
          ]}
        >
          <div
            class={[
              `${this.cssPrefix}__cell__wrapper`,
              'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--center-items',
              { 'sw-flexbox--center-justify': this.isLoadingData },
            ]}
          >
            {contentNodes}
          </div>
        </div>
      ));
    }

    const extraClasses = [];
    if (this.stripe) {
      if (this.index % 2) {
        extraClasses.push(`${this.cssPrefix}--contrast`);
      }
    }
    if (this.selected) {
      extraClasses.push(`${this.cssPrefix}--selected`);
    }
    if (this.nestLevel > 0 || this.noBackground) {
      extraClasses.push(`${this.cssPrefix}--no-background`);
    }
    if (this.size !== 'normal') {
      extraClasses.push(`${this.cssPrefix}--${this.size}`);
    }
    if (this.entry && this.entry._className) {
      extraClasses.push(this.entry._className);
    }
    if (this.isDragging) {
      extraClasses.push(`${this.cssPrefix}--dragging`);
    }

    const rootNode = (
      <div
        class={[
          `${this.cssPrefix}`, `${this.cssPrefix}--${this.theme}`,
          `${this.cssPrefix}--${this.instanceId}`,
          'sw-flexbox',
          ...extraClasses,
        ]}
        onClick={this.onClickRow}
        onMouseenter={this.onEnterRow}
        onMouseleave={this.onLeaveRow}
        onMousemove={this.onMouseMove}
      >
        {cellsNodes}
      </div>
    );

    return rootNode as VNode;
  }

  private created() {
    this.eventSubscription = utilService.eventbus.subscribe((event) => {
      if (event.type === EVENT_TYPE.EXPAND) {
        const eventData = event.value as InternalExpandEventData;
        if (!this.entry || this.entry._key !== eventData.entryKey) { return; }
        if (eventData.toExpand === this.expanded) { return; }
        this.onTryExpand();
      }
    });
  }

  private beforeDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
      this.eventSubscription = null;
    }
  }
}
